import { makeStyles } from "@mui/styles";

const white = "#FFFFFF";
const grey100 = "#F5F5F5";
const grey200 = "#EEEEEE";
const grey300 = "#E0E0E0";
const grey400 = "#BDBDBD";
const grey500 = "#9E9E9E";
const grey600 = "#757575";
const grey700 = "#616161";
const grey900 = "#212121";
const blue50 = "#E3F2FD";
const blue100 = "#BBDEFB";
const turquoise = "#1ABC9C";   // usado en UI (focus, botones, borders) — NO en iconos
const appBarPurple = "#1A093E";

export const useBuscadorGlobalStyles = makeStyles((theme) => ({
  // ── Contenedor ───────────────────────────────────────────────
  contenedor: {
    position: "relative",
    width: "100%",
    maxWidth: 560,
    flex: 1,
    maxHeight: 36,
    flexBasis:"content"
  },

  // ── Input (reposo y foco) ────────────────────────────────────
  papelInput: {
    display: "flex",
    alignItems: "center",
    padding: "0 12px 0 14px",
    backgroundColor: white,
    borderRadius: 6,
    height: 36,
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      borderColor: grey400,
    },
    "&:focus-within": {
      borderColor: turquoise,
      boxShadow: "0 0 0 2px " + blue50,
    },
  },
  inputBase: {
    flex: 1,
  },
  iconoBusqueda: {
    color: grey500,
    transition: "color 0.15s",
    fontSize: 20,
    flexShrink: 0,
  },
  iconoLoading: {
    flexShrink: 0,
  },

  // ── Dropdown / Popper ────────────────────────────────────────
  popper: {
    zIndex: 9999,
    marginTop: 4,
  },
  contenedorDropdown: {
    backgroundColor: white,
    borderRadius: 8,
    border: "1px solid " + grey200,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.06)",
    display:"flex",
    flexDirection:"column",
    flexWrap: "wrap",
    maxHeight: 420,
    overflow: "hidden",
    overflowY: "auto",
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: grey300,
      borderRadius: 3,
      "&:hover": { backgroundColor: grey400 },
    },
  },

  // ── Header de sección ───────────────────────────────────────
  seccionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 14px 8px",
    borderBottom: "1px solid " + grey100,
  },
  tituloSeccion: {
    fontWeight: 600,
    fontSize: "0.65rem",
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: grey600,
  },
  botonLimpiar: {
    fontSize: "0.7rem",
    fontWeight: 500,
    textTransform: "none",
    color: turquoise,
    padding: "2px 6px",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: blue50,
    },
  },

  // ── Lista ───────────────────────────────────────────────────
  listaResultados: {
    padding: "2px 0 4px",
  },

  // ── Item de resultado ───────────────────────────────────────
  itemResultado: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0px 5px 20px !important",
    cursor: "pointer",
    transition: "background-color 0.12s ease",
    "&:hover": {
      backgroundColor: blue50,
      borderLeftColor: turquoise,
    },
  },
  itemResultadoHighlighted: {
    backgroundColor: blue50,
    borderLeftColor: turquoise,
    "&:hover": {
      backgroundColor: blue100,
    },
  },
  itemResultadoDeshabilitado: {
    opacity: 0.4,
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "transparent",
      borderLeftColor: "transparent",
    },
  },
  iconoItem: {
    marginRight: 1,
    flexShrink: 0,
    fontSize: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconoItemDisabled: {
    color: grey300,
  },
  // ── Icono Material Icons (sidebar style) ──────────────────────
  iconoMaterial: {
   
    fontSize: 18,
    width: 24,
    height: 24,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconoMaterialVacio: {
    width: 24,
    height: 24,
    borderRadius: 4,
    backgroundColor: "#E8F6F3",
    flexShrink: 0,
  },
  contenedorTexto: {
    flex: 1,
    minWidth: 0,
  },
  tituloItem: {
    fontWeight: 500,
    fontSize: "0.875rem",
    color: grey900,
    whiteSpace: "wrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: 1.4,
  },
  subtituloItem: {
    fontSize: "0.75rem",
    color: grey600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: 1.3,
    marginTop: 1,
  },
  iconoLock: {
    color: grey400,
    fontSize: 16,
    flexShrink: 0,
    marginLeft: 8,
  },

  // ── Grupo de módulo ────────────────────────────────────────────
  grupoModulo: {
    display: "flex",
    flexDirection: "column",
  },
  grupoHeader: {
    display: "flex",
    alignItems: "center",
    padding: "6px 14px 4px",
    backgroundColor: grey100,
    borderBottom: "1px solid " + grey200,
  },
  grupoIconoModulo: {
    fontSize: 14,
    color: appBarPurple,
    marginRight: 6,
    display: "inline-flex",
    alignItems: "center",
  },

  // ── Botón eliminar ────────────────────────────────────────
  botonEliminar: {
    padding: 4,
    minWidth: "auto",
    color: grey400,
    borderRadius: 4,
    flexShrink: 0,
    marginLeft: 4,
    "&:hover": {
      backgroundColor: "#FFEBEE",
      color: "#D32F2F",
    },
  },

  // ── Sin resultados ────────────────────────────────────────
  contenedorSinResultados: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "28px 20px",
    width: "100%",
    boxSizing: "border-box",
    minWidth: 300,
  },
  iconoSinResultados: {
    fontSize: "2.2rem",
    marginBottom: 10,
    color: grey400,
  },
  textoSinResultados: {
    fontSize: "0.875rem",
    color: grey700,
    textAlign: "center",
    fontWeight: 400,
    lineHeight: 1.5,
  },
}));
